import { Component, OnInit } from '@angular/core';
import { NbIconLibraries, NbThemeService } from '@nebular/theme';
import { UserService } from 'src/app/shared/service/user.service';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { WithdrawModel } from 'src/app/shared/models/withdraw.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: []
})
export class AppComponent implements OnInit {
  withdrawAlertInterval!: any;
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  constructor(
    private iconLibraries: NbIconLibraries,
    private themeService: NbThemeService,
    private userService: UserService,
    private authenticationService: AuthenticationService
  ) {
    this.iconLibraries.registerFontPack('font-awesome-light', {
      packClass: 'fal',
      iconClassPrefix: 'fa'
    });
    this.iconLibraries.registerFontPack('font-awesome-brand', {
      packClass: 'fab',
      iconClassPrefix: 'fa'
    });
    this.iconLibraries.registerFontPack('font-awesome-regular', {
      packClass: 'far',
      iconClassPrefix: 'fa'
    });
    this.iconLibraries.registerFontPack('font-awesome-solid', {
      packClass: 'fas',
      iconClassPrefix: 'fa'
    });
    const theme = localStorage.getItem('theme');
    this.themeService.changeTheme((theme === '1' || theme === '0' ? 'cosmic' : theme) ?? 'cosmic');
  }

  getWithdrawRequest(): () => void {
    let withdrawList: WithdrawModel[] = [];
    return () => {
      const withdrawAlert = this.userService.getWithdrawAlert();
      if (withdrawAlert.show && this.authenticationService.getToken() !== undefined) {
        this.userService.withdrawList().subscribe((list) => {
          if (
            list.length > 0 &&
            (withdrawList.length === 0 ||
              withdrawList[withdrawList.length - 1]?.id !== list[list.length - 1]?.id)
          ) {
            this.Toast.fire({
              text: 'درخواست برداشت جدید ثبت شد',
              icon: 'info'
            });
            if (!withdrawAlert.silent) {
              const notification = new Audio('/assets/notification-sound/withdraw-crypto.mp3');
              notification.play();
            }
          }
          withdrawList = list;
          this.userService.withdrawRequest.next(list);
        });
      }
    };
  }

  ngOnInit(): void {
    if (this.authenticationService.checkScope('AND', 'admin:view:users:withdraw')) {
      const withdrawAlert = this.userService.getWithdrawAlert();
      if (withdrawAlert.show) {
        const withdrawRequest = this.getWithdrawRequest();
        setTimeout(() => {
          withdrawRequest();
        }, 500);
        this.withdrawAlertInterval = setInterval(() => {
          withdrawRequest();
        }, 60000);
      }
    }
  }
}
